import Navbar from '../../components/navbar/navbar';
import useSetSiteLanguage from '../../hooks/useSetSiteLanguage';
import './servicesPageStyle.css'
import ContentBlock from './../../components/contentBlock/contentBlock'
import H2Title from './../../components/text/h2Title/h2Title'
import Footer from './../../components/footer/footer'


export default function ServicesPage() {
    const siteContent = useSetSiteLanguage();

    return (
        <>
            <Navbar data={siteContent?.navbar} />
            <div className='services-page__container'>
                <H2Title title={siteContent?.servicesPage?.summary?.title} />
                
                <ContentBlock
                    text={siteContent?.servicesPage?.summary?.text}
                    photo={siteContent?.servicesPage?.summary?.photo}
                />

                <div className='services-page__content-wrapper'>
                    {siteContent?.servicesPage?.services.map( (item, index) => (
                        <ContentBlock
                            title={item.title}
                            photo={item.photo}
                            text={item.text}
                            type={item.type}
                            key={index}/>
                    ))}
                </div>  
            </div>
            <Footer />
        </>
    );
}
